import {FC} from "react";
import {SvgIconProps} from "@mui/material";
import {useRecoilValue} from "recoil";
import {PanelLayout} from "../providers/layout/LayoutProvider";
import {LocalizationsAtom} from "../providers/localization/LocalizationProvider";

export const TradeInIcon: FC<SvgIconProps & { type: 'main' | 'contrast' }> = (props) => {
   const value = useRecoilValue(PanelLayout(props.type))
   const localizations = useRecoilValue(LocalizationsAtom);

   if(localizations.frontPageStep1Image) {
      return <img src={localizations.frontPageStep1Image} alt="Trade in" style={{width: '45px', height: '45px'}}/>
   }

   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"
           fill={value.textColor || '#000000'}>
         <g id="Group_132" data-name="Group 132" transform="translate(-38 -817)">
            <rect id="Rectangle_125" data-name="Rectangle 125" width="45" height="45" transform="translate(38 817)"
                  fill="none"/>
            <g id="Group_84" data-name="Group 84" transform="translate(43.5 819.5)">
               <path id="Path_37" data-name="Path 37"
                     d="M-140.2,51.077a4.109,4.109,0,0,0-.369-.541,2.027,2.027,0,0,0-.866-.591,2.907,2.907,0,0,0-2.141.222,45.265,45.265,0,0,1-4.592,1.939l-.033.013-.033-.007c-.465-.095-.779-.464-.986-1.155a4.526,4.526,0,0,1,.054-2.582l5.355-13.123a6.5,6.5,0,0,0,.386-1.654,1.906,1.906,0,0,0-.093-.814,1.273,1.273,0,0,0-.661-.7l-1.626-.671a1.371,1.371,0,0,0-.868.06,1.691,1.691,0,0,0-.6.476,7.236,7.236,0,0,0-.885,1.427c-.916,1.769-2.043,4.147-3.038,6.245l-.114.24c-1.078,2.277-1.75,3.651-2.117,4.326l-.037.068-7-.356a5.1,5.1,0,0,0-1.708.193,2.388,2.388,0,0,0-1.711,1.428l0,.006A61.058,61.058,0,0,0-166.7,55.773a4.561,4.561,0,0,0,.066,1.85,2.034,2.034,0,0,0,1.123,1.5l8.323,3.429a3.624,3.624,0,0,0,.639.182,2.925,2.925,0,0,0,.512.045A3.068,3.068,0,0,0-155,62.6c.086-.033.169-.071.294-.129l.089-.04c3.036-1.318,7.307-3.985,12.691-7.92a9.678,9.678,0,0,0,1.428-1.235A2.252,2.252,0,0,0-140.2,51.077Zm-5.284-16.453-5.355,13.126a6.045,6.045,0,0,0-.1,3.7,3.254,3.254,0,0,0,2.689,2.5,1.006,1.006,0,0,0,.357-.032,36.321,36.321,0,0,0,5.023-2.1,1.433,1.433,0,0,1,.84-.179.4.4,0,0,1,.2.2c.062.167.062.167-.054.318a10.169,10.169,0,0,1-1.084.915,73.293,73.293,0,0,1-12.429,7.75,1.681,1.681,0,0,1-.846.149l-.165-.034c-1.882-.768-3.9-1.6-5.889-2.425l-2.472-1.022a1.206,1.206,0,0,1-.117-.288,2.955,2.955,0,0,1-.041-1.129,59.33,59.33,0,0,1,2.74-9.965c.013-.04.135-.174.5-.286a3.9,3.9,0,0,1,1.124-.126l7.472.382a1.109,1.109,0,0,0,.978-.532c.453-.77,1.265-2.485,2.205-4.472l.208-.44c1.034-2.183,2.214-4.66,3.123-6.418.162-.312.309-.58.442-.8a1.8,1.8,0,0,1,.085-.159l.831.345A5.773,5.773,0,0,1-145.485,34.625Z"
                     transform="translate(166.76 -22.777)"/>
               <g id="Group_79" data-name="Group 79" transform="translate(5.454 2.75)">
                  <path id="Path_38" data-name="Path 38"
                        d="M-160.508,27.992h-.016a.738.738,0,0,1-.727-.739,1.691,1.691,0,0,1,1.732-1.745.745.745,0,0,1,.742.748.745.745,0,0,1-.742.748c-.111,0-.237,0-.247.263A.753.753,0,0,1-160.508,27.992Z"
                        transform="translate(161.25 -25.509)"/>
               </g>
               <path id="Path_39" data-name="Path 39"
                     d="M-134.04,22.75h-12.17a1.48,1.48,0,0,0-1.474,1.483v6.828l.233-.164a2.855,2.855,0,0,1,.254-.172,2.379,2.379,0,0,1,.3-.185h0l0,0a2.576,2.576,0,0,1,.521-.147l.17-.034-.011-6.11,12.158-.012.012,12.245h-9.021l-.435,1.066-.175.43h9.63a1.48,1.48,0,0,0,1.473-1.483V24.233A1.48,1.48,0,0,0-134.04,22.75Z"
                     transform="translate(166.567 -22.75)"/>
               <path id="Path_40" data-name="Path 40"
                     d="M-162.277,37.973H-151.5c.238-.5.475-1,.715-1.5l-11.484.012-.012-12.245,12.158-.012V35.1l.309-.62c.144-.29.278-.556.417-.83s.265-.531.392-.778c.058-.125.135-.25.206-.377.053-.1.1-.2.161-.3V24.233a1.479,1.479,0,0,0-1.473-1.483h-12.17a1.479,1.479,0,0,0-1.473,1.483V36.49A1.479,1.479,0,0,0-162.277,37.973Z"
                     transform="translate(166.73 -22.75)"/>
            </g>
         </g>
      </svg>
   );
}


export const PackItIcon: FC<SvgIconProps & { type: 'main' | 'contrast' }> = (props) => {
   const value = useRecoilValue(PanelLayout(props.type))
   const localizations = useRecoilValue(LocalizationsAtom);

   if(localizations.frontPageStep2Image) {
      return <img src={localizations.frontPageStep2Image} alt="Pack it" style={{width: '45px', height: '45px'}}/>
   }

   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"
           fill={value.textColor || '#000000'}>
         <g id="Group_133" data-name="Group 133" transform="translate(5411 -4226)">
            <rect id="Rectangle_126" data-name="Rectangle 126" width="45" height="45" transform="translate(-5411 4226)"
                  fill="none"/>
            <g id="Group_85" data-name="Group 85" transform="translate(-1.536 115.857)">
               <g id="Group_82" data-name="Group 82" transform="translate(-5406.964 4114.143)">
                  <g id="Group_80" data-name="Group 80" transform="translate(0 4.282)">
                     <path id="Path_42" data-name="Path 42"
                           d="M-87.76,42.146l-3.133-6.564a.976.976,0,0,0-.454-.415l-9.818-3.467c.016.028.038.051.054.08a2.728,2.728,0,0,1,.284,1.668l6.961,2.477-13.819,4.859L-121.5,35.87l9.526-3.35a2.708,2.708,0,0,1-.142-1.55L-124,35.182a.76.76,0,0,0-.416.4l-3.191,6.582a.9.9,0,0,0-.026.632.673.673,0,0,0,.428.39l2.687.935V55.742a.7.7,0,0,0,.5.685l16.1,5.7a.745.745,0,0,0,.21.023.7.7,0,0,0,.265-.024l16.084-5.7a.791.791,0,0,0,.517-.712V44.175l2.67-.93a.69.69,0,0,0,.451-.414A1.025,1.025,0,0,0-87.76,42.146Zm-38.13-.121,2.524-5.2,14.667,5.171-2.522,5.2Zm17.448,18.3-14.566-5.19V44.684l11.947,4.2a.787.787,0,0,0,.214.024h0a.723.723,0,0,0,.673-.418l1.728-3.688Zm1.516.1V44.86l1.726,3.681a.729.729,0,0,0,.652.422.541.541,0,0,0,.242-.023l11.947-4.2V55.23Zm2.781-13.18-2.522-5.2L-92,36.871l2.523,5.206Z"
                           transform="translate(127.683 -29.438)"/>
                     <path id="Path_43" data-name="Path 43"
                           d="M-107.85,29.491l.021-.028c-.018,0-.035.005-.053.006A.365.365,0,0,1-107.85,29.491Z"
                           transform="translate(127.841 -29.463)"/>
                  </g>
                  <path id="Path_44" data-name="Path 44"
                        d="M-97.031,25.25a12.3,12.3,0,0,0-10.646,7.823l-1.173-1.947a.893.893,0,0,0-1.235-.3.911.911,0,0,0-.3,1.246l2.625,4.361,4.562-2.467a.909.909,0,0,0,.367-1.227.894.894,0,0,0-1.218-.371l-1.787.967a10.253,10.253,0,0,1,8.806-6.267.9.9,0,0,0,.9-.907A.9.9,0,0,0-97.031,25.25Z"
                        transform="translate(127.82 -25.25)"/>
                  <g id="Group_81" data-name="Group 81" transform="translate(6.571 22.521)">
                     <path id="Path_45" data-name="Path 45"
                           d="M-120.408,53.854a.759.759,0,0,1-.756-.762V48.17a.759.759,0,0,1,.756-.762.759.759,0,0,1,.756.762v4.921A.759.759,0,0,1-120.408,53.854Z"
                           transform="translate(121.164 -47.408)"/>
                  </g>
               </g>
            </g>
         </g>
      </svg>
   );
}

export const DropOffIcon: FC<SvgIconProps & { type: 'main' | 'contrast' }> = (props) => {
   const value = useRecoilValue(PanelLayout(props.type))

   const localizations = useRecoilValue(LocalizationsAtom);

   if(localizations.frontPageStep3Image) {
      return <img src={localizations.frontPageStep3Image} alt="Drop it off" style={{width: '45px', height: '45px'}}/>
   }

   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"
           fill={value.textColor || '#000000'}>
         <g id="Group_134" data-name="Group 134" transform="translate(-36 -1081)">
            <rect id="Rectangle_127" data-name="Rectangle 127" width="45" height="45" transform="translate(36 1081)"
                  fill="none"/>
            <g id="Group_86" data-name="Group 86" transform="translate(5403.143 -3027.639)">
               <path id="Path_41" data-name="Path 41"
                     d="M-48.773,32.277a.717.717,0,0,0-.243-.443l-8.116-6.9a.772.772,0,0,0-.5-.183H-74.88a.769.769,0,0,0-.538.217l-7.1,6.9a1.882,1.882,0,0,0-.481.786,1.847,1.847,0,0,0-.25.913V57.834a1.947,1.947,0,0,0,1.971,1.916h31.058a1.947,1.947,0,0,0,1.971-1.916V33.567A1.876,1.876,0,0,0-48.773,32.277Zm-2.77-.626H-64.989V26.229h7.069Zm-23.022-5.423h8.054v5.423H-80.145Zm24.793,31.606a.444.444,0,0,1-.449.437H-81.279a.444.444,0,0,1-.449-.437V33.567a.444.444,0,0,1,.449-.437h31.058a.444.444,0,0,1,.449.437Z"
                     transform="translate(-5278.892 4088.889)"/>
               <path id="Path_46" data-name="Path 46"
                     d="M-61.81,47.4a.776.776,0,0,0-1.072-.08l-2.295,1.911V39.989a.751.751,0,0,0-.761-.739.751.751,0,0,0-.761.739v9.237l-2.295-1.911a.776.776,0,0,0-1.072.08.724.724,0,0,0,.082,1.042l4.046,3.371,4.046-3.371A.724.724,0,0,0-61.81,47.4Z"
                     transform="translate(-5278.703 4088.685)"/>
               <path id="Path_47" data-name="Path 47"
                     d="M-56,36.244v-.016a.743.743,0,0,1,.752-.724,1.7,1.7,0,0,1,1.775,1.725.751.751,0,0,1-.761.739.751.751,0,0,1-.761-.739c0-.11,0-.236-.268-.246A.758.758,0,0,1-56,36.244Z"
                     transform="translate(-5278.497 4088.738)"/>
            </g>
         </g>
      </svg>
   );
}

export const AddItemIcon: FC<SvgIconProps & { iconcolor?: string | null, iconsize?: string }> = ({
                                                                                                    iconcolor,
                                                                                                    iconsize
                                                                                                 }) => {
   return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={iconsize || '22px'}
               height={iconsize || '22px'}>
      <g id="Tilføj" transform="translate(1 1)">
         <path id="Path_100" data-name="Path 100"
               d="M-14286.565-18745a.989.989,0,0,1-1-.979v-20.043a.989.989,0,0,1,1-.979.989.989,0,0,1,1,.979v20.043A.989.989,0,0,1-14286.565-18745Z"
               transform="translate(14296.566 18766)" fill={iconcolor || "#FF5376"}/>
         <path id="Path_101" data-name="Path 101"
               d="M1,22a.99.99,0,0,1-1-.979V.979A.99.99,0,0,1,1,0,.99.99,0,0,1,2,.979V21.021A.99.99,0,0,1,1,22Z"
               transform="translate(21 8.999) rotate(90)" fill={iconcolor || "#FF5376"}/>
      </g>
   </svg>
}

export const CameraIcon: FC<SvgIconProps & { iconcolor?: string }> = ({iconcolor}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
               fill={iconcolor || "#FF5376"}>
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path
         d="M14.12 4l1.83 2H20v12H4V6h4.05l1.83-2h4.24M15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm-3 7c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z"/>
   </svg>
}

export const DeleteIcon: FC<SvgIconProps & { iconcolor?: string }> = ({iconcolor}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
               fill={iconcolor || "#000000"}>
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"/>
   </svg>
}

export const CloseIcon: FC<SvgIconProps & { iconcolor?: string }> = ({iconcolor}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
               fill={iconcolor || "#000000"} style={{width: '24px', height: '24px'}}>
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path
         d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
   </svg>
}

export const ArrowIcon: FC<SvgIconProps & { iconcolor?: string }> = ({iconcolor, ...rest}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"
               fill={iconcolor || '#000000'} {...rest}>
      <path id="Pil"
            d="M.805,6.788H13.283L7.849,1.6a.779.779,0,0,1,0-1.1A.794.794,0,0,1,8.956.5L16,7.287,8.855,14.075a.745.745,0,1,1-1.006-1.1L12.78,8.286H.805A.791.791,0,0,1,0,7.487.711.711,0,0,1,.805,6.788Z"
            transform="translate(0 -0.275)"/>
   </svg>
}


export const ArrowIconBack: FC<SvgIconProps & { iconcolor?: string }> = ({iconcolor, ...rest}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"
               fill={iconcolor || '#000000'} {...rest}>
      <path id="Pil"
            d="M.805,6.788H13.283L7.849,1.6a.779.779,0,0,1,0-1.1A.794.794,0,0,1,8.956.5L16,7.287,8.855,14.075a.745.745,0,1,1-1.006-1.1L12.78,8.286H.805A.791.791,0,0,1,0,7.487.711.711,0,0,1,.805,6.788Z"
            transform="translate(0 -0.275) rotate(180 8 7)"/>
   </svg>
}


export const SearchIcon: FC<SvgIconProps & { iconcolor?: string }> = ({iconcolor}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
               fill={iconcolor || '#000000'}>
      <path
         d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
   </svg>
}

export const CheckBox: FC<SvgIconProps & { iconcolor?: string }> = ({iconcolor, ...rest}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
               fill={iconcolor || '#000000'} {...rest}>
      <path
         d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
   </svg>
}

export const UnCheckBox: FC<SvgIconProps & { iconcolor?: string }> = ({iconcolor, ...rest}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
               fill={iconcolor || '#000000'} {...rest}>
      <path
         d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
   </svg>
}

export const Checked: FC<SvgIconProps & { iconcolor?: string, iconsize?: string }> = ({iconcolor, iconsize}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width={iconsize} height={iconsize} viewBox={"0 0 533 533"}
               fill={iconcolor || '#000000'}>
      <path d="M477.931,52.261c-12.821-12.821-33.605-12.821-46.427,0l-266.96,266.954l-62.075-62.069
			c-12.821-12.821-33.604-12.821-46.426,0L9.616,303.572c-12.821,12.821-12.821,33.604,0,46.426l85.289,85.289l46.426,46.426
			c12.821,12.821,33.611,12.821,46.426,0l46.426-46.426l290.173-290.174c12.821-12.821,12.821-33.605,0-46.426L477.931,52.261z"/>
   </svg>
}

export const Voucher: FC<SvgIconProps & { iconcolor?: string, iconsize?: string }> = ({iconcolor, iconsize}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width={iconsize} height={iconsize} viewBox={"0 0 120 120"}
               fill={iconcolor || '#000000'}>
      <g>
         <path fill="#F8A100"
               d="M99.9,50.6h1.3c2.2,0,4-1.8,4-4v-6.3c0-2.2-1.8-4-4-4H18.9c-2.2,0-4,1.8-4,4v6.3c0,2.2,1.8,4,4,4h1.3   c2.2,0,4,1.8,4,4v10.9c0,2.2-1.8,4-4,4h-1.3c-2.2,0-4,1.8-4,4v6.3c0,2.2,1.8,4,4,4h82.3c2.2,0,4-1.8,4-4v-6.3c0-2.2-1.8-4-4-4h-1.3   c-2.2,0-4-1.8-4-4V54.6C95.9,52.4,97.7,50.6,99.9,50.6z M36.1,76.9c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5.4c0-0.6,0.4-1,1-1s1,0.4,1,1   V76.9z M36.1,67.4c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5.4c0-0.6,0.4-1,1-1s1,0.4,1,1V67.4z M36.1,57.9c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5.4   c0-0.6,0.4-1,1-1s1,0.4,1,1V57.9z M36.1,48.5c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5.4c0-0.6,0.4-1,1-1s1,0.4,1,1V48.5z M85.9,76.9   c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5.4c0-0.6,0.4-1,1-1s1,0.4,1,1V76.9z M85.9,67.4c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5.4c0-0.6,0.4-1,1-1   s1,0.4,1,1V67.4z M85.9,57.9c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5.4c0-0.6,0.4-1,1-1s1,0.4,1,1V57.9z M85.9,48.5c0,0.6-0.4,1-1,1   s-1-0.4-1-1v-5.4c0-0.6,0.4-1,1-1s1,0.4,1,1V48.5z"/>
         <g opacity="0.1">
            <path
               d="M102.7,82.8H20.4c-2.2,0-4-1.8-4-4v-6.3c0-1.2,0.5-2.2,1.4-3c-1.7,0.4-2.9,2-2.9,3.8v6.3c0,2.2,1.8,4,4,4h82.3    c1,0,1.9-0.4,2.6-1C103.4,82.7,103.1,82.8,102.7,82.8z"/>
            <path
               d="M18.9,50.6h1.3c2.2,0,4,1.8,4,4v10.9c0,1.2-0.5,2.2-1.4,3c1.7-0.4,2.9-2,2.9-3.8V53.7c0-2.2-1.8-4-4-4h-1.3    c-2.2,0-4-1.8-4-4v-6.3c0-1.2,0.5-2.2,1.4-3c-1.7,0.4-2.9,2-2.9,3.8v6.3C14.9,48.8,16.7,50.6,18.9,50.6z"/>
         </g>
         <g>
            <g opacity="0.15">
               <path
                  d="M49.5,61.4c-1.4,0-2.6-0.3-3.7-0.9c-1.1-0.6-2-1.5-2.6-2.6c-0.7-1.1-1-2.5-1-4.1c0-1.6,0.3-2.9,1-4.1     c0.7-1.1,1.5-2,2.6-2.6c1.1-0.6,2.3-0.9,3.7-0.9c1.4,0,2.6,0.3,3.7,0.9c1.1,0.6,2,1.5,2.6,2.6c0.7,1.1,1,2.5,1,4.1s-0.3,3-1,4.1     c-0.7,1.2-1.5,2-2.6,2.6C52.2,61.1,50.9,61.4,49.5,61.4z M47,73.8l18.5-27.1H72L53.5,73.8H47z M49.5,57.3c0.4,0,0.8-0.2,1.2-0.7     c0.4-0.5,0.5-1.4,0.5-2.6c0-1.3-0.1-2.2-0.5-2.6c-0.4-0.5-0.7-0.7-1.2-0.7c-0.4,0-0.8,0.2-1.2,0.7c-0.4,0.5-0.5,1.4-0.5,2.6     c0,1.3,0.1,2.2,0.5,2.6C48.7,57,49.2,57.3,49.5,57.3z M69.4,74.2c-1.4,0-2.6-0.3-3.7-0.9c-1.1-0.6-2-1.5-2.6-2.6     c-0.7-1.1-1-2.5-1-4.1c0-1.6,0.3-2.9,1-4.1c0.7-1.1,1.5-2,2.6-2.6c1.1-0.6,2.3-0.9,3.7-0.9c1.3,0,2.6,0.3,3.7,0.9     c1.1,0.6,2,1.5,2.6,2.6c0.7,1.1,1,2.5,1,4.1c0,1.6-0.3,3-1,4.1c-0.7,1.2-1.5,2-2.6,2.6C72,73.9,70.8,74.2,69.4,74.2z M69.4,70.1     c0.4,0,0.8-0.2,1.2-0.7c0.4-0.5,0.5-1.4,0.5-2.6c0-1.3-0.1-2.2-0.5-2.6c-0.4-0.5-0.7-0.7-1.2-0.7c-0.4,0-0.8,0.2-1.2,0.7     c-0.4,0.5-0.5,1.4-0.5,2.6c0,1.3,0.1,2.2,0.5,2.6C68.6,69.8,69,70.1,69.4,70.1z"/>
            </g>
            <g>
               <path fill="#F4C70C"
                     d="M50.6,60.8c-1.4,0-2.6-0.3-3.7-0.9c-1.1-0.6-2-1.5-2.6-2.6c-0.7-1.2-1-2.5-1-4.1s0.3-2.9,1-4.1     c0.7-1.1,1.5-2,2.6-2.6c1.1-0.6,2.3-0.9,3.7-0.9c1.4,0,2.6,0.3,3.7,0.9c1.1,0.6,2,1.5,2.6,2.6c0.7,1.1,1,2.5,1,4.1     c0,1.6-0.3,3-1,4.1c-0.7,1.2-1.5,2-2.6,2.6C53.2,60.5,52,60.8,50.6,60.8z M48.1,73.2l18.5-27.1h6.5L54.6,73.2H48.1z M50.6,56.7     c0.4,0,0.8-0.2,1.2-0.7c0.4-0.5,0.5-1.4,0.5-2.6c0-1.3-0.1-2.2-0.5-2.6c-0.4-0.5-0.7-0.7-1.2-0.7c-0.4,0-0.8,0.2-1.2,0.7     s-0.5,1.4-0.5,2.6c0,1.3,0.1,2.2,0.5,2.6C49.8,56.4,50.2,56.7,50.6,56.7z M70.5,73.6c-1.4,0-2.6-0.3-3.7-0.9     c-1.1-0.6-2-1.5-2.6-2.6c-0.7-1.1-1-2.5-1-4.1c0-1.6,0.3-2.9,1-4.1c0.7-1.1,1.5-2,2.6-2.6c1.1-0.6,2.3-0.9,3.7-0.9     c1.3,0,2.6,0.3,3.7,0.9c1.1,0.6,2,1.5,2.6,2.6c0.7,1.1,1,2.5,1,4.1c0,1.6-0.3,3-1,4.1c-0.7,1.2-1.5,2-2.6,2.6     C73,73.3,71.9,73.6,70.5,73.6z M70.5,69.4c0.4,0,0.8-0.2,1.2-0.7s0.5-1.4,0.5-2.6c0-1.3-0.1-2.2-0.5-2.6     c-0.4-0.5-0.7-0.7-1.2-0.7c-0.4,0-0.8,0.2-1.2,0.7s-0.5,1.4-0.5,2.6c0,1.3,0.1,2.2,0.5,2.6C69.7,69.2,70,69.4,70.5,69.4z"/>
            </g>
         </g>
      </g>
   </svg>
}

export const Mobilepay: FC<SvgIconProps & { iconcolor?: string, iconsize?: string }> = ({iconcolor, iconsize}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width={iconsize} height={iconsize} viewBox={"0 0 48 48"}
               fill={iconcolor || '#000000'}>
      <g id="a" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
         <g id="b" transform="translate(-21.000000, -24.000000)">
            <g id="danish-blue-large" transform="translate(21.000000, 24.000000)">
               <rect id="Background" fill="#5A78FF" x="0" y="0" width="48" height="48" rx="24"/>
               <g id="Logo-/-monochrome-/-symbol-/-white" transform="translate(11.000000, 11.000000)" fill="#FFFFFF">
                  <g id="Logo_monochrome_lines" transform="translate(0.764706, 0.382353)">
                     <path
                        d="M11.8529412,16.7365084 C13.9709276,16.0910306 15.7627795,15.7664759 17.2284968,15.7628444 C19.6517368,15.7568404 21.6834143,16.2378531 23.3235294,17.2058824 L23.3235294,10.1662664 C21.6750873,9.31267556 19.8125189,8.85702497 17.7358241,8.7993146 C15.6591294,8.74160424 13.6981684,9.16453394 11.8529412,10.0681037 L11.8529412,16.7365084 Z"
                        id="Path-4"/>
                     <path
                        d="M8.41176471,9.07195384 L11.025752,15.2941176 L11.025752,9.33099477 C12.4029934,8.59349174 13.8610171,8.12085267 15.3998232,7.91307756 C16.9386292,7.70530244 18.6877078,7.73880158 20.6470588,8.01357497 L19.2253774,4.61677985 C17.165744,4.48377212 15.2036939,4.81559182 13.3392269,5.61223896 C11.47476,6.4088861 9.83227258,7.56212439 8.41176471,9.07195384 Z"
                        id="Path-4"/>
                     <path
                        d="M16.4411765,6.51927915 C16.4411765,5.91889364 16.4411765,5.01831538 16.4411765,3.81754437 C16.4411765,2.55384363 15.4229778,1.52941176 14.1669661,1.52941176 L6.48009274,1.52941176 C5.22408102,1.52941176 4.20588235,2.55384363 4.20588235,3.81754437 L4.20588235,21.8001027 C4.20588235,23.0638034 5.22408102,24.0882353 6.48009274,24.0882353 L14.1669661,24.0882353 C15.4229778,24.0882353 16.4411765,23.0638034 16.4411765,21.8001027 C16.4411765,20.6612641 16.4411765,19.9181304 16.4411765,19.5707018 C16.0923547,19.402244 15.8360101,19.2817348 15.6721426,19.2091741 C15.49909,19.1325464 15.2500546,19.029273 14.9250362,18.899354 C14.9250362,19.3470246 14.9250362,20.3139408 14.9250362,21.8001027 C14.9250362,22.2213363 14.5856367,22.5628136 14.1669661,22.5628136 L6.48009274,22.5628136 C6.06142217,22.5628136 5.72202261,22.2213363 5.72202261,21.8001027 L5.72202261,3.81754437 C5.72202261,3.39631079 6.06142217,3.0548335 6.48009274,3.0548335 L14.1669661,3.0548335 C14.5856367,3.0548335 14.9250362,3.39631079 14.9250362,3.81754437 L14.9250362,6.54837213 C15.2815657,6.5258784 15.5527734,6.51554513 15.7386594,6.51737232 C15.9245455,6.5191995 16.1587178,6.51983512 16.4411765,6.51927915 Z"
                        id="Path-5" fill-rule="nonzero"
                        transform="translate(10.323529, 12.808824) rotate(-22.400000) translate(-10.323529, -12.808824) "/>
                  </g>
               </g>
            </g>
         </g>
      </g>
   </svg>
}

export const Creditcard: FC<SvgIconProps & { iconcolor?: string, iconsize?: string }> = ({iconcolor, iconsize}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width={iconsize} height={iconsize} x="0px" y="0px"
               viewBox={"0 0 64 64"} fill={iconcolor || '#000000'}>
      <g id="Layer_1">
         <g>
            <circle fill="#77B3D4" cx="32" cy="32" r="32"/>
         </g>
         <g opacity={"0.2"}>
            <path fill="#231F20"
                  d="M52,45c0,2.2-1.8,4-4,4H16c-2.2,0-4-1.8-4-4V25c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4V45z"/>
         </g>
         <g>
            <path fill="#FFFFFF"
                  d="M52,43c0,2.2-1.8,4-4,4H16c-2.2,0-4-1.8-4-4V23c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4V43z"/>
         </g>
         <g>
            <rect x="12" y="25" fill="#4F5D73" width="40" height="6"/>
         </g>
         <g>
            <circle fill="#E0995E" cx="38" cy="41" r="2"/>
         </g>
         <g>
            <circle fill="#E0995E" cx="46" cy="41" r="2"/>
         </g>
         <g>
            <circle fill="#E0995E" cx="30" cy="41" r="2"/>
         </g>
      </g>
   </svg>
}


export const Scanner: FC<SvgIconProps & { iconcolor?: string, iconsize?: string }> = ({iconcolor, iconsize}) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width={iconsize || '24px'} height={iconsize || '24px'} x="0px" y="0px"
               viewBox={"0 0 24 24"} fill={iconcolor || '#000000'}>
      <path
         d="M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"></path>
   </svg>
}

export const SearchByCategory: FC<SvgIconProps & { iconcolor?: string, iconsize?: string }> = ({
                                                                                                  iconcolor,
                                                                                                  iconsize,
                                                                                                  ...rest
                                                                                               }) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width={iconsize || '24px'} height={iconsize || '24px'} x="0px" y="0px"
               viewBox={"0 0 48 48"} fill={iconcolor || '#000000'} {...rest}>
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
      <g id="SVGRepo_iconCarrier"><title>category</title>
         <g id="Layer_2" data-name="Layer 2">
            <g id="invisible_box" data-name="invisible box">
               <rect width="48" height="48" fill="none"></rect>
            </g>
            <g id="icons_Q2" data-name="icons Q2">
               <path
                  d="M24,7.7,29.3,16H18.6L24,7.7M24,2a2.1,2.1,0,0,0-1.7,1L13.2,17a2.3,2.3,0,0,0,0,2,1.9,1.9,0,0,0,1.7,1H33a2.1,2.1,0,0,0,1.7-1,1.8,1.8,0,0,0,0-2l-9-14A1.9,1.9,0,0,0,24,2Z"></path>
               <path
                  d="M43,43H29a2,2,0,0,1-2-2V27a2,2,0,0,1,2-2H43a2,2,0,0,1,2,2V41A2,2,0,0,1,43,43ZM31,39H41V29H31Z"></path>
               <path d="M13,28a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-4A10,10,0,1,0,23,34,10,10,0,0,0,13,24Z"></path>
            </g>
         </g>
      </g>
   </svg>
}

export const SearchByKeyword: FC<SvgIconProps & { iconcolor?: string, iconsize?: string }> = ({
                                                                                                 iconcolor,
                                                                                                 iconsize,
                                                                                                 ...rest
                                                                                              }) => {
   return <svg xmlns="http://www.w3.org/2000/svg" width={iconsize || '24px'} height={iconsize || '24px'} x="0px" y="0px"
               viewBox={"0 0 24 24"} fill={iconcolor || 'none'} {...rest}>
         <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
         <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
         <g id="SVGRepo_iconCarrier">
            <path
               d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
               stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
         </g>
      </svg>
}

